import sound from 'assets/audio/incoming_message.mp3'

class NotificationAudioService {
  audio: HTMLAudioElement;
  audioCtx: AudioContext | null = null;
  lastPlay = 0;

  constructor() {
    this.audio = new Audio(sound);
    this.audio.preload = 'auto';
  }

  async enableSound() {
    const isSafari =
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
      /Apple Computer, Inc./.test(navigator.vendor);
    localStorage.setItem('alreadyAllowSound', 'true');

    if (isSafari) {
      const prevVolume = this.audio.volume;
      this.audio.volume = 0;

      try {
        await this.audio.play();
      } catch (e) {
        console.error('Safari unlock failed', e);
        localStorage.setItem('alreadyAllowSound', 'false');
        return false;
      }

      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio.volume = prevVolume;

      return true;
    }

    try {
      if (!this.audioCtx) {
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      }

      if (this.audioCtx.state === 'suspended') {
        await this.audioCtx.resume();
      }

      const buffer = this.audioCtx.createBuffer(1, 1, 22050);
      const source = this.audioCtx.createBufferSource();
      source.buffer = buffer;
      source.connect(this.audioCtx.destination);
      source.start(0);

      return true;
    } catch (e) {
      console.error('WebAudio unlock failed', e);
      localStorage.setItem('alreadyAllowSound', 'false');
      return false;
    }
  }

  play() {
    const now = Date.now();
    if (now - this.lastPlay < 1000) return; // троттлинг
    this.lastPlay = now;

    this.audio.currentTime = 0;
    this.audio.play().catch(console.error);
  }
}

export const notificationAudioService = new NotificationAudioService();
